import React, { useState, useEffect } from "react";
import "./AdminPage.css"; // فایل CSS خودتان
import api, { setAuthToken } from "../../api/baseUrl";
import edidIcon from "../../icons/edit.svg"
import axios from "axios";
import TableProducts from "../../components/Table/TableProducts/TableProducts"

import Table from "../../components/Table/Table";

import InvoiceMraketer from "../../components/In/InvoiceMraketer";
import { useUser } from "../../context/UserContext";
import TableV2 from "../../components/Table/TableV2";
import TableVisitors from "../../components/Table/TableVisitors";
import Snackbar from "../../components/SnackBar/SnackBar";
import { useLocation } from "react-router-dom";
import TableMarketers from "../../components/Table/TableMarketers/TableMarketers";
import TableSellers from "../../components/Table/TableSellers/TableSellers";
import visitorIcon from '../../icons/Property 1=linear (6).svg';
import sellerIcon from '../../icons/Property 1=linear (6).svg';
import orderIcon from '../../icons/Property 1=linear (6).svg';
import productIcon from '../../icons/Property 1=linear (6).svg';
// import LogoutButton from "../../components/LogoutButton/LogoutButton";



const AdminPage = () => {
  const [activePage, setActivePage] = useState("visitors"); // پیش‌فرض روی فروشنده
  const [vendorModalOpen, setVendorModalOpen] = useState(false);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ message: "", type: "info" });


  const [marketers, setMarketers] = useState(); // ← اضافه شد
  const [orders, setOrders] = useState(); // ← اضافه شد


  const [visitors, setVisitors] = useState(); // ← اضافه شد
  const [sellers, setSellers] = useState(); // ← اضافه شد
  const [products, setProducts] = useState(); // ← اضافه شد

  const [getDataAllInvoice, setGetDataAllInvoice] = useState(null);

  const [userId, setUserId] = useState(); // ← اضافه شد

  const { adminName } = useUser();

  const [sellersPagesCount, setSellersPagesCount] = useState(); // ← اضافه شد

  //   const handleFetchMarketers = async (page = 1) => {
  //   try {
  //     const response = await api.get("/get-marketers", { params: { page } });


  //     // این برای استیت لوکال در parent
  //       setVisitors(response.data.messages)

  //     // این برای TableProducts
  //     return {
  //       messages: response.data.messages,
  //       pagesCount: response.data.pagesCount,
  //     };
  //   } catch (err) {
  //     console.error("Fetch Products Error:", err.response?.data || err.message);
  //     return { messages: [], pagesCount: 1 }; // جلوگیری از undefined
  //   }
  // };

  // const handleFetchMarketers = async (page = 1, search = "") => {
  //   try {
  //     const response = await api.get("/get-marketers", {
  //       params: { page, s: search }, // 👈 اضافه شد: s برای سرچ
  //     });

  //     setVisitors(response.data.messages)
  //     // برای TableProducts
  //     return {
  //       messages: response.data.messages,
  //       pagesCount: response.data.pagesCount,
  //     };
  //   } catch (err) {
  //     console.error("Fetch Products Error:", err.response?.data || err.message);
  //     return { messages: [], pagesCount: 1 };
  //   }
  // };
const handleFetchMarketers = async (page = 1, search = "", isArchive = false) => {
  try {
    const response = await api.get("/get-marketers", {
      params: {
        ...(isArchive && { data: "archive" }),
        s: search,
        page,
      },
    });

    // داده‌های عادی و آرشیو رو جدا کن
    const normalMarketers = isArchive ? [] : response.data.messages;
    const archiveMarketers = isArchive ? response.data.messages : [];

    // برای استیت محلی در parent
    setVisitors(normalMarketers);


    

    return {
      normalMessages: normalMarketers,
      archiveMessages: archiveMarketers,
      pagesCount: response.data.pagesCount,
      totalNormal: response.data.totalNormal || normalMarketers.length,
      totalArchive: response.data.totalArchive || archiveMarketers.length,
    };
  } catch (err) {
    console.error("Fetch Marketers Error:", err.response?.data || err.message);
    return { normalMessages: [], archiveMessages: [], pagesCount: 1 };
  }
};




  // const handleFetchSellers = async () => {

  //   try {



  //     const response = await api.get("/get-sellers");
  //     // setVisitors(response.data.messages)

  //     setSellers(response.data)

  //     console.log("/get-sellers",response.data);





  //   } catch (err) {
  //     console.error("Login Error:", err.response?.data || err.message);
  //     // setSnackbar({ message: "خطا در ورود!", type: "error" });
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  // const handleFetchSellers = async (page = 1, search = "") => {
  //   try {
  //     const response = await api.get("/get-sellers", {
  //       params: { page, s: search }, // 👈 اضافه شد: s برای سرچ
  //     });

  //     console.log("Get products", response.data);

  //     // برای استیت محلی در parent
  //     setSellers(response.data);

  //     // برای TableProducts
  //     return {
  //       messages: response.data.messages,
  //       pagesCount: response.data.pagesCount,
  //     };
  //   } catch (err) {
  //     console.error("Fetch Products Error:", err.response?.data || err.message);
  //     return { messages: [], pagesCount: 1 };
  //   }
  // };


  const handleFetchSellers = async (page = 1, search = "", isArchive = false) => {
  try {
    const response = await api.get("/get-sellers", {
      params: {
        ...(isArchive && { data: "archive" }),
        s: search,
        page,
      },
    });


    // تفکیک داده‌ها
    const normalSellers = isArchive ? [] : response.data.messages;
    const archiveSellers = isArchive ? response.data.messages : [];


    // فقط داده‌های عادی رو توی استیت بگذار
    setSellers(normalSellers);

    return {
      normalMessages: normalSellers,
      archiveMessages: archiveSellers,
      pagesCount: response.data.pagesCount,
      totalNormal: response.data.totalNormal || normalSellers.length,
      totalArchive: response.data.totalArchive || archiveSellers.length,
    };

  } catch (err) {
    console.error("Fetch Sellers Error:", err.response?.data || err.message);
    return { normalMessages: [], archiveMessages: [], pagesCount: 1 };
  }
};




  const handleFetchProducts = async (page = 1, search = "", isArchive = false) => {
    try {
      const response = await api.get("/get-products", {
        params: {
          ...(isArchive && { data: "archive" }),
          s: search,
          page,
        },
      });


      // داده‌های عادی و آرشیو رو جدا کن
      const normalProducts = isArchive ? [] : response.data.messages;
      const archiveProducts = isArchive ? response.data.messages : [];


      // برای استیت محلی در parent
      setProducts(normalProducts);

      return {
        normalMessages: normalProducts,
        archiveMessages: archiveProducts,
        pagesCount: response.data.pagesCount,
        totalNormal: response.data.totalNormal || normalProducts.length,  // تعداد کل محصولات فعال
        totalArchive: response.data.totalArchive || archiveProducts.length, // تعداد کل محصولات آرشیو
      };

    } catch (err) {
      console.error("Fetch Products Error:", err.response?.data || err.message);
      return { normalMessages: [], archiveMessages: [], pagesCount: 1 };
    }
  };



  const handleFetchInvoices = async (page = 1, search = "") => {
    try {
      const response = await api.get("/get-invoices", { params: { page, search } });


      // این برای استیت لوکال در parent
      setOrders(response.data.messages)

      // این برای TableProducts
      return {
        messages: response.data.messages,
        pagesCount: response.data.pagesCount,
        allData:response.data.count,
        invoiceCount:response.data.invoiceCount,
        invoiceCountWeek:response.data.invoiceCountWeek,
        invoiceCountToday:response.data.invoiceCountToday
      };
    } catch (err) {
      console.error("Fetch Products Error:", err.response?.data || err.message);
      return { messages: [], pagesCount: 1 }; // جلوگیری از undefined
    }
  };


  const handleGetDataAllInvoice = async () => {
    try {
      const result = await api.post("/crud-invoices", { action: "get", invoice_id: 2026140507 });

      setGetDataAllInvoice(result.data)

      if (result.data.accepted && result.data.message) {
        // setInvoiceDetails(result.data.message[0]); // فرض بر این است که سرور object فاکتور را برمی‌گرداند
        // setShowInvoiceModal(true);


      } else {
        alert("اطلاعات فاکتور یافت نشد");
      }
    } catch (error) {
      console.error("خطا در دریافت فاکتور:", error);
      alert("خطا در دریافت اطلاعات فاکتور");
    }
  };



  useEffect(() => {
    if (activePage === "visitors") {
      handleFetchMarketers();
    } else if (activePage === "sellers") {
      handleFetchSellers();
    }

    else if (activePage === "products") {
      handleFetchProducts()
    }


    else if (activePage === "orders") {
      handleFetchInvoices()
      // handleGetDataAllInvoice()
    }
  }, [activePage]);



  <InvoiceMraketer
    orders={orders}
    visitors={visitors}
    sellers={sellers}
    products={products}
    refreshDataProducts={handleFetchProducts}
    refreshDataSeller={handleFetchSellers}
    refreshDataInvoices={handleFetchInvoices}
  />
  return (
    <div className="wrap">

      <div className="app">
        <Sidebar activePage={activePage} setActivePage={setActivePage} adminName={adminName} />
        <main className="main">
          {activePage === "visitors" && <Visitors visitors={visitors} userId={userId} refreshData={handleFetchMarketers} />}
          {activePage === "sellers" && <Sellers sellers={sellers} refreshDataSeller={handleFetchSellers} />}

          {activePage === "orders" && <Orders orders={orders}
            visitors={visitors}    // لیست ویزیتورها
            sellers={sellers}      // لیست فروشنده‌ها
            products={products}
            refreshDataProducts={handleFetchProducts}
            refreshDataSeller={handleFetchSellers}
            refreshDataInvoices={handleFetchInvoices}

          />
          }
          {activePage === "products" && <Products products={products} refreshDataProducts={handleFetchProducts} />}
        </main>
      </div>


      <Snackbar
        message={snackbar.message}
        type={snackbar.type}
        duration={3000}
        onClose={() => setSnackbar({ message: "", type: "info" })}
      />
    </div>
  );
};




const Sidebar = ({ activePage, setActivePage, adminName, handleLogout }) => {
  const [isOpen, setIsOpen] = useState(true);

  const links = [
    {
      id: "visitors",
      label: "ویزیتور ها",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.0001 7.16C17.9401 7.15 17.8701 7.15 17.8101 7.16C16.4301 7.11 15.3301 5.98 15.3301 4.58C15.3301 3.15 16.4801 2 17.9101 2C19.3401 2 20.4901 3.16 20.4901 4.58C20.4801 5.98 19.3801 7.11 18.0001 7.16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M16.9704 14.4402C18.3404 14.6702 19.8504 14.4302 20.9104 13.7202C22.3204 12.7802 22.3204 11.2402 20.9104 10.3002C19.8404 9.59016 18.3104 9.35016 16.9404 9.59016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5.97047 7.16C6.03047 7.15 6.10047 7.15 6.16047 7.16C7.54047 7.11 8.64047 5.98 8.64047 4.58C8.64047 3.15 7.49047 2 6.06047 2C4.63047 2 3.48047 3.16 3.48047 4.58C3.49047 5.98 4.59047 7.11 5.97047 7.16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.00043 14.4402C5.63043 14.6702 4.12043 14.4302 3.06043 13.7202C1.65043 12.7802 1.65043 11.2402 3.06043 10.3002C4.13043 9.59016 5.66043 9.35016 7.03043 9.59016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12.0001 14.6302C11.9401 14.6202 11.8701 14.6202 11.8101 14.6302C10.4301 14.5802 9.33008 13.4502 9.33008 12.0502C9.33008 10.6202 10.4801 9.47021 11.9101 9.47021C13.3401 9.47021 14.4901 10.6302 14.4901 12.0502C14.4801 13.4502 13.3801 14.5902 12.0001 14.6302Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14.9097 17.7804C13.3197 16.7204 10.6897 16.7204 9.08973 17.7804C7.67973 18.7204 7.67973 20.2603 9.08973 21.2003C10.6897 22.2703 13.3097 22.2703 14.9097 21.2003" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      ),
    },
    {
      id: "sellers",
      label: "فروشگاه ها",
      icon: (
        /* SVG دیگر لینک ها را هم اینجا قرار بده */
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.01025 15.7102C3.01025 20.2002 4.81025 22.0002 9.30025 22.0002H14.6903C19.1803 22.0002 20.9803 20.2002 20.9803 15.7102V11.2202" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12.0005 12C13.8305 12 15.1805 10.51 15.0005 8.68L14.3405 2H9.67048L9.00048 8.68C8.82048 10.51 10.1705 12 12.0005 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M18.3103 12C20.3303 12 21.8103 10.36 21.6103 8.35L21.3303 5.6C20.9703 3 19.9703 2 17.3503 2H14.3003L15.0003 9.01C15.1703 10.66 16.6603 12 18.3103 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5.64037 12C7.29037 12 8.78037 10.66 8.94037 9.01L9.16037 6.8L9.64037 2H6.59037C3.97037 2 2.97037 3 2.61037 5.6L2.34037 8.35C2.14037 10.36 3.62037 12 5.64037 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12.0005 17C10.3305 17 9.50049 17.83 9.50049 19.5V22H14.5005V19.5C14.5005 17.83 13.6705 17 12.0005 17Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      ),

    },
    {
      id: "orders",
      label: "فاکتور ها",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 13.01H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9 9.01001H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M2 11V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5.99561 13H6.00459" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M5.99548 9H6.00447" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      ),

    },

    {
      id: "products",
      label: "محصولات ",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.1709 7.43994L12.0009 12.5499L20.7709 7.46991" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12.001 21.61V12.54" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14.0711 21.5201C13.5011 21.8401 12.7511 22.0001 12.0011 22.0001C11.2511 22.0001 10.5011 21.8401 9.93109 21.5201L4.59109 18.5601C3.38109 17.8901 2.39111 16.2101 2.39111 14.8301" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M21.6111 12.83V9.17C21.6111 7.79 20.6211 6.11002 19.4111 5.44002L14.0711 2.48C12.9311 1.84 11.0711 1.84 9.93109 2.48L4.59109 5.44002C3.38109 6.11002 2.39111 7.79 2.39111 9.17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M19.201 21.4C20.9683 21.4 22.401 19.9673 22.401 18.2C22.401 16.4327 20.9683 15 19.201 15C17.4337 15 16.001 16.4327 16.001 18.2C16.001 19.9673 17.4337 21.4 19.201 21.4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M23.001 22L22.001 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      ),

    },
  ];



  return (
    <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="brand">
        <h1 className={isOpen ? "visible" : "hidden"}>سلام، {adminName}</h1>

        <label className="hamburger toggle-btn">
          <input
            type="checkbox"
            checked={isOpen}
            onChange={() => setIsOpen(!isOpen)}
          />
          <svg viewBox="0 0 32 32">
            <path
              className="line line-top-bottom"
              d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
            ></path>
            <path className="line" d="M7 16 27 16"></path>
          </svg>
        </label>
      </div>

      <nav className="nav">
        {links.map((link) => (
          <a
            key={link.id}
            data-label={link.label}
            className={activePage === link.id ? "active" : ""}
            onClick={() => setActivePage(link.id)}
          >
            <span className="dot">{link.icon}</span>
            <span className="label">{link.label}</span>
          </a>
        ))}
      </nav>
      {/* <LogoutButton /> */}
    </aside>

  );
};
const Visitors = ({ visitors, refreshData }) => (
  <section className="card">




    <TableMarketers
      marketers={visitors} refreshDataMarketers={refreshData} title="ویزیتور ها"
    />

  </section>
);

const Sellers = ({ sellers, refreshDataSeller }) => (
  <section className="card">

    <TableSellers
      sellers={sellers} refreshDataSellers={refreshDataSeller} title="فروشگاه ها"
    />


  </section>
);









const Orders = ({ orders, visitors,
  sellers, products, refreshDataProducts, refreshDataSeller, refreshDataInvoices
}) => <div id="ordersPage">

    <section className="card">



      <Table
        title="سفارشات"
        searchPlaceholder="جستجوی سفارش..."
        orders={orders}
        visitors={visitors}    // لیست ویزیتورها
        sellers={sellers}      // لیست فروشنده‌ها
        products={products}    // لیست محصولات
        refreshDataProducts={refreshDataProducts}
        refreshDataSeller={refreshDataSeller}
        refreshDataInvoices={refreshDataInvoices}
      />


    </section>








  </div>;
















const Products = ({ products, refreshDataProducts }) => (
  <div id="productsPage">
    <section className="card">

      <TableProducts
        products={products} refreshDataProducts={refreshDataProducts} />

    </section>






  </div>
);





export default AdminPage;


